var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 1300,
            "footer-hide": true,
            title: "定金单废单明细",
            draggable: "",
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          staticClass: "form-input-no-outline",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "订单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.billCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "苗场" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.seedFarmName,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .depositBillRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "周期" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.weekSeq,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "发货时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateString(
                                            _vm.orderRecord
                                              .depositBillRecordSendProductDate
                                          ),
                                        },
                                        model: {
                                          value: _vm.sendDeliveryDate,
                                          callback: function ($$v) {
                                            _vm.sendDeliveryDate = $$v
                                          },
                                          expression: "sendDeliveryDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "支付状态" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.paidStatus,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单总额(元)" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.mainTotalMoney,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "待付金额(元)" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.orderRecord.remainingSum,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "关联销售单号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "10" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "客户地址" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.receiptFullAddress,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "10" } },
                                [
                                  _vm.$checkAccessArray(["B", "C"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "苗场备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value: _vm.orderRecord.remark,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$checkAccessArray(["S", "G"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "苗场备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value: _vm.orderRecord.remark,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "8" } },
                                [
                                  _vm.$checkAccessArray(["S", "B"])
                                    ? _c(
                                        "FormItem",
                                        { attrs: { label: "客户备注" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.orderRecord.customerMsg,
                                              readonly: "",
                                              type: "textarea",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "佣金比例" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .depositBillDetailSalesAssociateCommissionPercent,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_c("b", [_vm._v("定金单明细")])]
                                      ),
                                      _c("Table", {
                                        ref: "mainTable",
                                        attrs: {
                                          size: "small",
                                          columns: _vm.orderDetail.columns,
                                          data: _vm.orderDetail.rows,
                                          stripe: "",
                                          border: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right", "padding-bottom": "30px" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { type: "error" },
                      on: {
                        click: function ($event) {
                          _vm.show = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }